// extracted by mini-css-extract-plugin
export default {"scrollable":"scrollbar_scrollable__O0YBz"};